import { axiosInstance } from './index';
import {
    AuthResponseType,
    AutoSignInAuthResponseType,
    CandidateRequestType,
    HrmsManagerRequestType,
    HRMSUserResponseType,
    LinkedinResponseType,
    ManagerJoinByInvitationType,
    ManagerRequestType,
    socialSignInType,
    UserResponseType,
    verifyAndSignInType,
} from '../../types/auth';

export const authService = {
    async socialSignIn(data: socialSignInType) {
        const { data: responseData } = await axiosInstance.post('user/SignIn', data);
        return responseData as AuthResponseType;
    },

    async hrmsSignIn(data: socialSignInType) {
        const { data: responseData } = await axiosInstance.post('HRMSUser/HRMSSignIn', data);
        return responseData as AuthResponseType;
    },

    async hrmsSignUp(data: HrmsManagerRequestType) {
        const { data: responseData } = await axiosInstance.post('HRMSUser/HRMSUserSignUp', data);
        return responseData as AuthResponseType;
    },

    async candidateSignUp(data: CandidateRequestType) {
        const { data: responseData } = await axiosInstance.post('user/CandidateSignUp', data);
        return responseData as AuthResponseType;
    },

    async managerSignUp(data: ManagerRequestType) {
        const { data: responseData } = await axiosInstance.post('user/ManagerSignUp', data);
        return responseData as AuthResponseType;
    },

    async managerJoinByInvitation(data: ManagerJoinByInvitationType) {
        await axiosInstance.post('user/ManagerJoinByInvitation', data);
    },

    async getUser() {
        const { data } = await axiosInstance.get('user');
        return data as UserResponseType;
    },

    async getHRMSUser() {
        const { data } = await axiosInstance.get('HRMSUser');
        return data as HRMSUserResponseType;
    },

    async linkedin(code: string) {
        const { data: responseData } = await axiosInstance.post('user/LinkedIn', { AuthCode: code });
        return responseData as LinkedinResponseType;
    },

    async VerifyAndSignIn(data: verifyAndSignInType) {
        const { data: responseData } = await axiosInstance.post('user/VerifyAndSignIn', data);
        return responseData as AutoSignInAuthResponseType;
    },
};
